import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode, faPlus } from '@fortawesome/free-solid-svg-icons'

type TallyMobileActionsProps = {
  visible: boolean
  canAdd: boolean
  showScan?: boolean
  onAdd: () => void
  onScan?: () => void
}

/** In-flow mobile action bar — sits between page content and Footer (not fixed). */
export const TallyMobileActions: React.FC<TallyMobileActionsProps> = ({
  visible,
  canAdd,
  showScan = false,
  onAdd,
  onScan,
}) => {
  if (!visible) return null
  if (!canAdd && !showScan) return null

  return (
    <div className="shrink-0 border-t border-base-300 bg-base-100 px-4 py-2 sm:hidden">
      <div className="mx-auto flex w-full max-w-md gap-2">
        {canAdd ? (
          <button type="button" className="btn btn-primary flex-1 h-12 min-h-0" onClick={onAdd}>
            <FontAwesomeIcon icon={faPlus} />
            Add
          </button>
        ) : null}
        {showScan && onScan ? (
          <button
            type="button"
            className={`btn btn-secondary ${canAdd ? 'flex-1' : 'w-full'} h-12 min-h-0`}
            onClick={onScan}
          >
            <FontAwesomeIcon icon={faBarcode} />
            Scan
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default TallyMobileActions
